import { Component, OnInit } from '@angular/core';
import { IPersonal } from 'src/app/interfaces/Personal';
import { IPlant } from 'src/app/interfaces/plant';
import { PersonalService } from 'src/app/services/personal.service';
import { CentroCostoService } from 'src/app/services/centro-costo.service';
import { PlantService } from 'src/app/services/plant.service';
import {Response} from "../../interfaces/response";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonalSaveComponent } from './personal-save/personal-save.component'

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit {

  personal: IPersonal[];
  plants: IPlant[];
  lastPage: number;
  sucursal: number;
  centroCostos: string;
  cedula: string;
  nombre_fc: string;
  orden_ceco: string;
  id: string;

  constructor(
    private personalService: PersonalService,
    private centroCostoService: CentroCostoService,
    private plantService: PlantService,
    private ngbModalRef: NgbModal
  ) { }

  ngOnInit(): void {
    this.refresh();
    this.getSucursales();
  }
  refresh(currentPage = 1, param1=null , param2=null , param3=null ) {

    console.log(this.sucursal);
    this.personalService.all(currentPage, this.cedula, this.sucursal, this.orden_ceco).subscribe(
      (res: Response) => {
        this.personal = res.data;
        this.lastPage = res.meta.last_page;
      }
    )
  }
  getSucursales() {
    this.plantService.allRecords().subscribe(
      (res: Response) => {
        this.plants = res.data;
        //this.getCentroCostos();

      }
    )
  }

  getCentroCostos(param2=null) {
    this.centroCostoService.allRecords(null, param2, null).subscribe(
      (res: Response) => {
        this.centroCostos = res.data;
        this.refresh(1, this.cedula, this.sucursal, this.orden_ceco );
      }
    )
  }

  delete(id: number) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.personalService.delete(id).subscribe(
        res => {
          this.personal = this.personal.filter(el => el.id !== id);
        }
      );
    }
  }

  mostrarBootstrapModal(id: number,tipo: string) {
    const opts = {
      windowClass: 'myCustomClass'
    };
//
    const modalRefNgBots = this.ngbModalRef.open(PersonalSaveComponent, opts);
//
    modalRefNgBots.componentInstance.id = id;
    modalRefNgBots.componentInstance.tipo = tipo;
//
    modalRefNgBots.componentInstance.closeMyModal = () => {
      modalRefNgBots.close();
    }
//
    modalRefNgBots.componentInstance.salida.subscribe(res => {

     // this.texto = res;
      //console.log('Recibo: ', res.success);
      if (res.success){
        alert("Grabado");
      }
      this.refresh();
      modalRefNgBots.close();
    });

  }

}

